<script lang="ts">
import { BILLED_ONLY_BODY, BILLED_ONLY_SHORT, BILLED_ONLY_TITLE } from "./copy";

// The billing promise, rendered the same way wherever a price appears. It is
// the argument the price rests on, so it is a block with its own ground and
// mark rather than a line of small print under the number.
//
// `line` is the same promise compressed for places that have no room for a
// block — a dashboard tile, a result footer. Both variants carry the same test
// id, so a page can be asserted to show the promise without knowing which shape
// it chose.
//
// A translated page passes its own words for the block; everything else shows
// the English promise from ./copy, as it always has.
let {
  variant = "block",
  copy = { title: BILLED_ONLY_TITLE, body: BILLED_ONLY_BODY },
}: { variant?: "block" | "line"; copy?: { title: string; body: string } } = $props();
</script>

{#if variant === "block"}
  <div
    class="flex gap-4 rounded-2xl border border-emerald-200 bg-emerald-50 p-6"
    data-testid="billed-only"
  >
    <span
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-base font-semibold text-white"
      aria-hidden="true">✓</span
    >
    <div>
      <p class="text-base font-semibold text-emerald-900">{copy.title}</p>
      <p class="mt-1.5 max-w-2xl text-sm text-emerald-800">{copy.body}</p>
    </div>
  </div>
{:else}
  <p
    class="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300"
    data-testid="billed-only"
  >
    <span aria-hidden="true">✓</span>
    {BILLED_ONLY_SHORT}
  </p>
{/if}
